import { render } from "./cans-pack-selector.vue?vue&type=template&id=b00f2c0e"
import script from "./cans-pack-selector.vue?vue&type=script&lang=js"
export * from "./cans-pack-selector.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/.worktrees/pdp-golive-uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__